// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/white-box.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/white-box-768.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/white-box-414.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ref-container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top;
  background-size: cover;
  margin-top: -17%;
  padding-top: 14%;
  z-index: 9999;
  position: relative;
}
@media screen and (max-width: 768px) {
  .ref-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    margin-top: -35%;
    padding-top: 30%;
  }
}
@media screen and (max-width: 535px) {
  .ref-container {
    margin-top: -34%;
    padding-top: 170px;
  }
}
@media screen and (max-width: 415px) {
  .ref-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    margin-top: -12%;
    padding-top: 25px;
  }
}
.ref-container img {
  width: 100%;
}
.ref-container_text {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.ref-container_title {
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: center;
  width: 650px;
  margin-top: 2px;
}
@media screen and (max-width: 768px) {
  .ref-container_title {
    font-size: 18px;
    line-height: 22px;
    width: 449px;
  }
}
@media screen and (max-width: 535px) {
  .ref-container_title {
    width: 414px;
  }
}
@media screen and (max-width: 415px) {
  .ref-container_title {
    font-size: 18px;
    line-height: 22px;
    width: 354px;
  }
}
@media screen and (max-width: 354px) {
  .ref-container_title {
    width: 100%;
  }
}
.ref-container_btn {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/HomeReference.scss"],"names":[],"mappings":"AAAA;EACI,iEAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AACJ;AACI;EARJ;IASQ,yDAAA;IACA,gBAAA;IACA,gBAAA;EAEN;AACF;AADI;EAbJ;IAcQ,gBAAA;IACA,kBAAA;EAIN;AACF;AAHI;EAjBJ;IAkBQ,yDAAA;IACA,gBAAA;IACA,iBAAA;EAMN;AACF;AAJI;EACI,WAAA;AAMR;AAJI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AAMR;AAJI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAMR;AALQ;EARJ;IASQ,eAAA;IACA,iBAAA;IACA,YAAA;EAQV;AACF;AAPQ;EAbJ;IAcQ,YAAA;EAUV;AACF;AATQ;EAhBJ;IAiBQ,eAAA;IACA,iBAAA;IACA,YAAA;EAYV;AACF;AAXQ;EArBJ;IAsBQ,WAAA;EAcV;AACF;AAXI;EACI,aAAA;EACA,uBAAA;AAaR","sourcesContent":[".ref-container {\n    background: url('../../assets/images/white-box.png') no-repeat top;\n    background-size: cover;\n    margin-top: -17%;\n    padding-top: 14%;\n    z-index: 9999;\n    position: relative;\n\n    @media screen and (max-width: 768px) {\n        background-image: url('../../assets/images/white-box-768.png');\n        margin-top: -35%;\n        padding-top: 30%;\n    }\n    @media screen and (max-width: 535px) {\n        margin-top: -34%;\n        padding-top: 170px;\n    }\n    @media screen and (max-width: 415px) {\n        background-image: url('../../assets/images/white-box-414.png');\n        margin-top: -12%;\n        padding-top: 25px;\n    }\n\n    img {\n        width: 100%;\n    }\n    &_text {\n        width: 100%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n    }\n    &_title {\n        font-size: 32px;\n        font-weight: 700;\n        line-height: 40px;\n        letter-spacing: 0em;\n        text-align: center;\n        width: 650px;\n        margin-top: 2px;\n        @media screen and (max-width: 768px) {\n            font-size: 18px;\n            line-height: 22px;\n            width: 449px;\n        }\n        @media screen and (max-width: 535px) {\n            width: 414px;\n        }\n        @media screen and (max-width: 415px) {\n            font-size: 18px;\n            line-height: 22px;\n            width: 354px;\n        }\n        @media screen and (max-width: 354px) {\n            width: 100%;\n        }\n    }\n\n    &_btn {\n        display: flex;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
